import { CommonMsgNodeProps, LinkMessageType } from '@/types/message'
import Bubble from '../bubble-new'
import styles from './index.module.scss'

interface LinkMsgProps extends CommonMsgNodeProps {
  node: LinkMessageType
}

const LinkMsg = (props: LinkMsgProps) => {
  const {
    node,
    // msgContent,
    useTypingComplete = false,
    onTypingComplete
  } = props

  const { value, display = 'block' } = node

  // const placement = msgContent?.placement || 'start'
  // const isGptMsg = placement === 'start'
  // && !isGptMsg

  const onClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault() // 阻止默认跳转

    window.open(node?.url, '_blank')
  }

  const isBlockLayout = display === 'block'

  return (
    <a
      className={styles.linkContainer}
      href={node?.url}
      onClick={onClick}
      style={{
        display: isBlockLayout ? 'flex' : 'inline',
        // color: '#4C73F9',
        textDecoration: 'underline !important'
      }}
      target="_blank"
    >
      <Bubble
        onTypingComplete={onTypingComplete}
        typing={useTypingComplete}
        // style={{
        //   color: '#4C73F9',
        // }}
        content={value}
      />
    </a>
  )
}

export default LinkMsg
